import { render } from "./EditVolumePromotion.vue?vue&type=template&id=8ae55192&scoped=true"
import script from "./EditVolumePromotion.vue?vue&type=script&lang=js"
export * from "./EditVolumePromotion.vue?vue&type=script&lang=js"

import "./EditVolumePromotion.vue?vue&type=style&index=0&id=8ae55192&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ae55192"]])

export default __exports__